import { render, staticRenderFns } from "./formpc.vue?vue&type=template&id=218a19a2"
import script from "./formpc.vue?vue&type=script&lang=js"
export * from "./formpc.vue?vue&type=script&lang=js"
import style0 from "./formpc.vue?vue&type=style&index=0&id=218a19a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports